/**
 * Puts each reversal directly after the entry it cancels, so the pair reads as one story.
 * Everything else keeps its order. A reversal whose original is not in the list stays where it was.
 * Pure: the same rows come back, only re-ordered.
 */
export function reversalsBesideOriginals<T>(items: T[], idOf: (t: T) => string, reversesOf: (t: T) => string | null): T[] {
  const ids = new Set(items.map(idOf))
  const byOriginal = new Map<string, T>()
  for (const t of items) {
    const target = reversesOf(t)
    if (target && ids.has(target)) byOriginal.set(target, t)
  }
  const out: T[] = []
  for (const t of items) {
    const target = reversesOf(t)
    if (target && ids.has(target)) continue // placed under its original below
    out.push(t)
    const rev = byOriginal.get(idOf(t))
    if (rev) out.push(rev)
  }
  return out
}
